import React, { useEffect } from "react";

function Footer() {
  const constructor = () => {};
  useEffect(() => {
    constructor();
  }, []);
  return (
    <React.Fragment>
      <div className="copyright">© 2018 - 2024 SEΠSE. All Rights Reserved.</div>
      <div id="scrolldown" className="container">
        <div className="scroll-arrow"></div>
        <div className="scroll-arrow"></div>
        <div className="scroll-arrow"></div>
      </div>
    </React.Fragment>
  );
}

export default Footer;
